export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] lg:h-[800px] overflow-hidden">
      {/* Background Image - Makeup items on wooden table with natural light */}
      <div className="absolute inset-0">
        <img
          src="https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/hero-makeup-table-01.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Light Overlay for text readability - warm and airy */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35" />

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-center px-4 md:px-6 z-10">
        {/* Small Label */}
        <p className="text-white/95 text-xs md:text-sm tracking-[0.3em] mb-6 md:mb-8 animate-fade-in-up">
          健康・美容トレンドをプロデュース
        </p>

        {/* Company Name - Big */}
        <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-wide leading-tight mb-4 animate-fade-in-up">
          株式会社
          <br className="sm:hidden" />
          <span className="text-white">TBM</span>
          <span className="text-white/85 font-light">健康美容研究所</span>
        </h1>

        {/* English Subtitle */}
        <p className="text-white/85 text-sm md:text-base font-light tracking-wider animate-fade-in-up">
          TBM Health & Beauty Research Institute
        </p>

        {/* Divider */}
        <div className="w-16 h-px bg-white/40 my-6 md:my-8 animate-fade-in-up" />

        {/* Tagline */}
        <p className="text-white/95 text-sm md:text-base leading-relaxed max-w-2xl animate-fade-in-up">
          群馬県高崎市を拠点に、教材・出版、新製品化、健康事業、サロン経営、コンサルティング、
          <br className="hidden sm:block" />
          スクール・セミナー、総合美容検定 — 美容業界の未来を創造する総合研究所
        </p>
      </div>

      {/* Scroll Down Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="text-white/80 text-[10px] tracking-[0.3em] font-medium">SCROLL</span>
        <div className="w-px h-8 bg-white/60 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-4 bg-white animate-scroll-down" />
        </div>
      </div>
    </section>
  );
}